import http from "./httpService";
import { getConfig } from "../config/config.js";
// import Resizer from "react-image-file-resizer";

const config = getConfig();
const serviceEndpoint = config.apiEndpoint + "/salas";

export async function getSala(recordId) {
  try {
    const response = await http.get(serviceEndpoint + "/" + recordId);
    return response.data.record;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function getSalas() {
  try {
    const response = await http.get(serviceEndpoint);
    return response.data.records;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function saveSala(data, parentId) {
  if (data._id) return await http.put(serviceEndpoint + "/" + data._id, data);
  else {
    data.parentId = parentId;
    const response = await http.post(serviceEndpoint, data);
    return response.data.record._id;
  }
}

export async function uploadFoto(id, data, oldFile) {
  const newData = new FormData();
  let file = data.get("file");
  // console.log("file");
  // console.log(file);
  // file = await resizeFile(file);
  // console.log("file resized");
  // console.log(file);
  newData.append("oldfile", oldFile);
  newData.append("file", file);

  try {
    const response = await http.post(serviceEndpoint + "/uploadFoto/" + id, newData);
    return response.data.filename;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return null;
  }
}

// const resizeFile = (file) => {
//   console.log("hago resize");
//   new Promise((resolve) => {
//     Resizer.imageFileResizer(
//       file,
//       450,
//       600,
//       "JPEG",
//       100,
//       0,
//       (uri) => {
//         resolve(uri);
//       },
//       "base64"
//     );
//   });
// };

export async function deleteSala(recordId) {
  return await http.delete(serviceEndpoint + "/" + recordId);
}

export async function getSalasSelect() {
  let items = [];
  try {
    const response = await http.get(serviceEndpoint);
    response.data.records.map((item) => {
      items.push({ value: item._id, label: item.descripcion });
    });
    return items;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}
